import { Injectable } from '@angular/core';
import { CleanFillGroupPolicyViewModel, GroupClient } from '@services/cleanfill-api/cleanfill-api.generated';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpGroupsService {
  constructor(private groupsClients: GroupClient) {}

  // TODO: user groupsClients method to get all groups when BE adds support
  getAllGroups(): Observable<CleanFillGroupPolicyViewModel[]> {
    return this.groupsClients.getAllGroups(undefined);
  }
}
